export default __webpack_public_path__ + "static/media/main-logo.c3331b41.png";